<template>
  <div class="container-fluid">

    <!-- <div class="row py-3">
      <div class="col-md-12">
        <h1 class="text-center">Client details</h1>
      </div>
    </div> -->

    <div class="row mt-5">
      <div class="col-md-12">
        <client-table :client="user" v-if="user"></client-table>
      </div>

      <div class="col-md-12" v-if="hasPortfolio">
        <div class="card portfolio-card">
          <div class="card-header">
            <h2>{{$t("Portfolio")}} #{{ user.portfolios[0] }}: {{ portfolioStats ? portfolioStats.totalValueBGN : null }} {{$t("BGN")}}</h2>
          </div>
          <div class="card-body">
            <b-tabs v-model="tabIndex">
              <!-- TAB #1 -->
              <b-tab :title="i18n.overview" active class="pt-5">
                <div v-if="portfolioAssets && portfolioAssets.length" class="mb-5">
                  <pie-chart :assets="portfolioAssets"></pie-chart>
                  <assets-table :coins="portfolioAssets"></assets-table>
                  <i18n path="priceUpdateInfo" tag="p">
                    <a place="source" href="https://coingecko.com/">https://coingecko.com/</a>
                    <span place="updateTime">{{ updateTime }}</span>
                  </i18n>
                </div>

                <h3>{{$t("ROI")}}</h3>
                <totals-table v-if="portfolioStats" :data="portfolioStats"></totals-table>
                <div v-if="!portfolioStats" class="alert text-center">{{$t("noData")}}</div>

              </b-tab>

              <!-- TAB #2 -->
              <b-tab :title="i18n.transactions" class="pt-5">
                <transactions-table v-if="tabIndex === 1" :portfolioId="user.portfolios[0]"></transactions-table>
              </b-tab>

              <!-- TAB #3 -->
              <b-tab :title="i18n.taxmodule" class="pt-5">
                <taxinfo-table :client="user" v-if="tabIndex === 2" :portfolioId="user.portfolios[0]"></taxinfo-table>
              </b-tab>

            </b-tabs>
          </div>
        </div>
      </div>

      <loading :loading="loading"></loading>

    </div>

  </div>
</template>


<script>
import AssetsTable from '../components/tables/AssetsTable'
import ClientTable from '../components/tables/ClientTable'
import TotalsTable from '../components/tables/PortfolioTotalsTable'
import TransactionsTable from '../components/tables/TransactionsTable'
import PieChart from '../components/charts/AssetsPieChart'
import TaxinfoTable from '../components/tables/TaxinfoTable'

export default {
  components: {
    ClientTable,
    TotalsTable,
    TransactionsTable,
    TaxinfoTable,
    AssetsTable,
    PieChart,
  },
  created() {
    this.loading = true
    this.$store.dispatch('loadPortfolioDetails', this.user.portfolios[0])
      .then(() => {
        this.hasPortfolio = true
      })
      .catch(() => {
        this.hasPortfolio = false
      })
      .finally(() => {
        this.loading = false
      })
  },
  data() {
    return {
      loading: false,
      tabIndex: null,
      hasPortfolio: null,
      i18n: {
        overview: this.$t('overview'),
        transactions: this.$t('transactions'),
        taxmodule: this.$t('taxmodule'),
      },
    }
  },
  computed: {
    user() {
      return this.$store.getters.getLoggedUser
    },
    portfolioStats() {
      return this.$store.getters.getSPStats
    },
    portfolioAssets() {
      return this.$store.getters.getSPAssets
    },
    updateTime() {
      return this.$store.getters.getUpdateTime
    },
  },
  watch: {
    '$i18n.locale': function() {
      this.i18n = {
        overview: this.$t('overview'),
        transactions: this.$t('transactions'),
        taxmodule: this.$t('taxmodule'),
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-client-app/pages/HomePage.vue